import { FeatureCollection, Point } from 'geojson';
import SingletonEventEmitterClass from '../SingletonEventEmitterClass';
import { findList } from '../../api/operation/heatMap';
import { point as createPoint } from '@turf/helpers';
import transform from 'geojson-transformer';

export default class HeatMapLoader extends SingletonEventEmitterClass {

  private _data: any[] = [];
  private _region?: string = undefined;

  public get geojson(): FeatureCollection<Point> {
    return {
      type: 'FeatureCollection',
      features: this._data.map((item: any) => {
        const coordinates = transform(item.location.lngLat, 'gcj02', 'wgs84');
        return createPoint(coordinates);
      }),
    };
  }

  public onMapLoad() {
    const region = localStorage.getItem('gide-region');
    if (region) {
      this._region = region;
      this.fetchData();
    }
  }

  public jumpRegion(regionId: string) {
    this._region = regionId;
    this.fetchData();
  }

  public async fetchData() {
    // const { data } = await findList(this._region! as string);
    // this._data = data;
    this._triggerUpdate();
  }

  public async refresh() {
    this.fetchData();
  }

  private _triggerUpdate() {
    this.emit('updated');
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/HeatMapLoader.ts